import { render, staticRenderFns } from "./Ellipse.vue?vue&type=template&id=fb6c0026&scoped=true&"
import script from "./Ellipse.vue?vue&type=script&lang=js&"
export * from "./Ellipse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6c0026",
  null
  
)

export default component.exports